  import React, { useMemo, useState, useEffect, useRef} from "react";
  // import SkSelect from "./SkSelect";
  import "../assets/css/pagination.css"; // We will create this specific CSS file


  const DOTS = "...";

  const usePagination = ({ totalCount, pageSize, currentPage, pagesPerGroup }) => {

    const paginationRange = useMemo(() => {
      const totalPages = Math.ceil(totalCount / pageSize);

      // if(totalPages <= pagesPerGroup)
      // const totalPageNumbers = siblingCount + 5;

      if (totalPages <= pagesPerGroup) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      }


      // const currentGroup = Math.ceil(currentPage / pagesPerGroup);

      let currentGroup;

      if(currentPage == 1 ) {
        currentGroup = 1
      }else{
        currentGroup = Math.floor((currentPage - 1) / pagesPerGroup ) + 1;
      

      if(currentPage % pagesPerGroup === 0){
        currentGroup++;
      }
      }

      const start = (currentGroup - 1) * pagesPerGroup + 1;
      const end = Math.min(start + pagesPerGroup - 1, totalPages);

      const pages= [];
      if (start > 1) {
        pages.push(1);

        if(start > 2) {
          pages.push(DOTS);
        }
      }

      for (let i = start; i <= end; i++){
        pages.push(i);
      }

      if (end < totalPages) {
        if(end < totalPages - 1 ) {
          pages.push(DOTS);
        }
        pages.push(totalPages)
      }
return pages;

       }, [totalCount, pageSize, currentPage, pagesPerGroup]);

    return paginationRange;
  };
      // const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
      // const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
      // const shouldShowLeftDots = leftSiblingIndex > 2;
      // const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

      // const firstPageIndex = 1;
      // const lastPageIndex = totalPageCount;

      // if (!shouldShowLeftDots && shouldShowRightDots) {
      //   let leftItemCount = 3 + 2 * siblingCount;
      //   let leftRange = Array.from({ length: leftItemCount }, (_, i) => i + 1);
      //   return [...leftRange, DOTS, totalPageCount];
      // }

      // if (shouldShowLeftDots && !shouldShowRightDots) {
      //   let rightItemCount = 3 + 2 * siblingCount;
      //   let rightRange = Array.from({ length: rightItemCount }, (_, i) => totalPageCount - rightItemCount + i + 1);
      //   return [firstPageIndex, DOTS, ...rightRange];
      // }

      // if (shouldShowLeftDots && shouldShowRightDots) {
      //   let middleRange = Array.from({ length: rightSiblingIndex - leftSiblingIndex + 1 }, (_, i) => leftSiblingIndex + i);
      //   return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
      // }
   

  const Pagination = ({
    onPageChange,
    totalCount,
    // siblingCount = 1,
    currentPage,
    pageSize,
    onPageSizeChange,
    pageSizeOptions = [5, 10, 50, 100]
  }) => {
    const paginationRange = usePagination({
      currentPage,
      totalCount,
      pageSize,
      pagesPerGroup: 5,
    });
        const [pageSizeOpen, setPageSizeOpen] = useState(false);
        const [openUpward, setOpenUpward] = useState(false);

const pageSizeRef = useRef(null);

const togglePageSizeDropdown = () => {
  if (!pageSizeOpen) {
    const rect = pageSizeRef.current?.getBoundingClientRect();

    if (rect) {
      const dropdownHeight =
        pageSizeOptions.length * 32 + 10;

      const spaceBelow =
        window.innerHeight - rect.bottom;

      const spaceAbove = rect.top;

      // Open upward only when there isn't enough
      // space below AND there is more space above.
      const shouldOpenUp =
        spaceBelow < dropdownHeight &&
        spaceAbove > spaceBelow;

      setOpenUpward(shouldOpenUp);
    }
  }

  setPageSizeOpen((prev) => !prev);
};

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      pageSizeRef.current &&
      !pageSizeRef.current.contains(event.target)
    ) {
      setPageSizeOpen(false);
    }
  };

  document.addEventListener(
    "mousedown",
    handleClickOutside
  );

  return () => {
    document.removeEventListener(
      "mousedown",
      handleClickOutside
    );
  };
}, []);


    // If data is empty, don't show anything
    if (currentPage === 0 || paginationRange?.length < 1) {
      return null;
    }

    const onNext = () => {
      if (currentPage < Math.ceil(totalCount / pageSize)) {
        onPageChange(currentPage + 1);
      }
    };

    const onPrevious = () => {
      if (currentPage > 1) {
        onPageChange(currentPage - 1);
      }
    };

    let lastPage = paginationRange[paginationRange?.length - 1];

    return (
      <div className="modern-pagination-wrapper">
        
        {/* 1. Rows Per Page Selector (Left Side) */}
        {onPageSizeChange && (
          <div className="rows-per-page">
            <span className="text-muted small fw-bold me-2">Rows per page:</span>
           <div className="pagination-page-size-select"
           ref={pageSizeRef}>

  <button
    type="button"
    className={`pagination-native-select ${
      pageSizeOpen ? "open" : ""
    }`}
   onClick={togglePageSizeDropdown}
  >
    <span>{pageSize}</span>

    <i
      className={`bi ${
        pageSizeOpen
          ? "bi-chevron-up"
          : "bi-chevron-down"
      }`}
    />
  </button>

  {pageSizeOpen && (
    <div className={`pagination-page-size-menu ${
      openUpward ? "open-upward" : "open-downward"
    }`}>
    
      {pageSizeOptions.map((size) => (
        <button
          key={size}
          type="button"
          className={`pagination-page-size-option ${
            Number(size) === Number(pageSize)
              ? "selected"
              : ""
          }`}
          onClick={() => {
            onPageSizeChange(Number(size));
            setPageSizeOpen(false);
          }}
        >
          <span>{size}</span>

          {Number(size) === Number(pageSize) && (
            <i className="bi bi-check"></i>
          )}
        </button>
      ))}
    </div>
  )}

</div>
          </div>
        )}

        {/* 2. The Pill Pagination (Right Side) */}
        <div className="pagination-pill">
          
          {/* Previous Arrow */}
          <button
            className="pill-arrow"
            disabled={currentPage === 1}
            onClick={onPrevious}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          {/* Page Numbers */}
          <div className="pill-numbers">
            {paginationRange.map((pageNumber, index) => {
              if (pageNumber === DOTS) {
                return <span key={`dots-${index}`} className="pill-dots">&#8230;</span>;
              }

              return (
                <button
                  key={`page-${pageNumber}`}
                  className={`pill-number ${pageNumber === currentPage ? "active" : ""}`}
                  onClick={() => onPageChange(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>

          {/* Next Arrow */}
          <button
            className="pill-arrow"
            disabled={currentPage === lastPage}
            onClick={onNext}
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    );
  };

  export default Pagination;